export default __webpack_public_path__ + "static/media/UNION_A5.7b3a7b6a.png";